// Config normalisation + defaults.
// projectId is the routing key (goes in the URL path); org/user ride in the payload.

export const DEFAULTS = {
  position: 'bottom-right', // bottom-right | bottom-left
  maxDurationMs: 20 * 60 * 1000, // 20 minutes — auto-stops and sends at the cap
  maxPayloadBytes: 40 * 1024 * 1024, // ~40MB approx — auto-stops and sends at the cap
  accent: '#5b5bd6',
  label: 'Add feedback',
  mask: [], // extra CSS selectors whose text rrweb masks (all input VALUES are always masked)
  block: [], // CSS selectors of subtrees rrweb must not record at all
  keepQueryParams: [], // query param names whose values survive network-URL redaction
  consentText: null, // optional one-liner shown in the pre-record panel
  dryRun: false, // when true (or no endpoint) the payload is logged, not POSTed
};

const ACCENT_RE = /^#(?:[0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$|^rgba?\([\d\s.,%/]+\)$|^hsla?\([\d\s.,%/deg]+\)$/;

export function normalizeConfig(raw = {}) {
  const cfg = { ...DEFAULTS, ...raw };

  if (!cfg.projectId) console.warn('[ff] config: missing projectId');

  // Accent is interpolated into CSS — accept only colour-literal shapes, never arbitrary strings.
  if (!ACCENT_RE.test(String(cfg.accent).trim())) {
    console.warn('[ff] config: invalid accent, using default');
    cfg.accent = DEFAULTS.accent;
  }
  cfg.label = String(cfg.label).slice(0, 40);
  cfg.mask = toStringArray(cfg.mask);
  cfg.block = toStringArray(cfg.block);
  cfg.keepQueryParams = toStringArray(cfg.keepQueryParams);

  // Compose the upload URL: {endpoint}/{projectId}/feedback
  const base = cfg.endpoint ? String(cfg.endpoint).replace(/\/+$/, '') : null;
  cfg.uploadUrl = base && cfg.projectId ? `${base}/${encodeURIComponent(cfg.projectId)}/feedback` : null;

  if (!cfg.uploadUrl) cfg.dryRun = true; // nowhere to send -> dry run

  return cfg;
}

function toStringArray(v) {
  if (!v) return [];
  return (Array.isArray(v) ? v : [v]).map(String).filter(Boolean);
}

// Optional <script data-project-id data-endpoint> fallback for static installs.
export function readDataAttrs() {
  const el = document.currentScript || document.querySelector('script[data-project-id]');
  if (!el) return {};
  const out = {};
  if (el.dataset.projectId) out.projectId = el.dataset.projectId;
  if (el.dataset.endpoint) out.endpoint = el.dataset.endpoint;
  if (el.dataset.ingestKey) out.ingestKey = el.dataset.ingestKey;
  return out;
}
